import React from "react";
import classes from "./ZipGameStepper.module.css";
import { useTranslation } from "react-i18next";

const ZipGameStepper = ({ currentStep = 1 }) => {

  const {t}=useTranslation();
  const step1Active = currentStep === 1;
  const step1Completed = currentStep > 1;

  const step2Active = currentStep === 2;
  const step2Completed = currentStep > 2;

  return (
    <div className={classes.stepperWrapper}>
      <div className={classes.stepItem}>
        <div
          className={`${classes.stepCircle} ${step1Active ? classes.stepCircleActive : ""
            } ${step1Completed ? classes.stepCircleCompleted : ""}`}
        >
          1
        </div>

        <p
          className={`${classes.stepLabel} ${step1Active ? classes.stepLabelActive : ""
            } ${step1Completed ? classes.stepLabelCompleted : ""}`}
        >
          {t("344")}
        </p>

        <div
          className={`${classes.stepLine} ${currentStep > 1 ? classes.stepLineCompleted : ""
            }`}
        />
      </div>

      <div className={classes.stepItem}>
        <div
          className={`${classes.stepCircle} ${step2Active ? classes.stepCircleActive : ""
            } ${step2Completed ? classes.stepCircleCompleted : ""}`}
        >
          2
        </div>

        <p
          className={`${classes.stepLabel} ${step2Active ? classes.stepLabelActive : ""
            } ${step2Completed ? classes.stepLabelCompleted : ""}`}
        >
          {t("345")}
        </p>
      </div>
    </div>
  );
};

export default ZipGameStepper;